import { pluck, map } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { TOKEN_SUCCESS } from '../../../constants/actionTypes'
import syncActions, { syncType } from '../../../actions/sync'
import { ReduxAction, State } from '../../../reducers/reducerType'
import { debug } from '@bt-react/libs/Logger'
import { fetchToken } from '../../../actions/setup/setupActions'

const initiate$ = (actions$, state$: StateObservable<State>, { SyncClient }) => actions$.pipe(
  ofType(TOKEN_SUCCESS, syncType.TOKEN_RENEWAL_SUCCESS, syncType.SYNC_CLIENT_DISCONNECTED),
  pluck<ReduxAction<string>, string>('payload'),
  map(token => {

    const _token = token || state$.value.config.token

    if (!_token) {

      debug('No valid token to initialise the Sync Client')
      return fetchToken(state$.value.config.roomname, state$.value.config.username)

    }

    const client = new SyncClient(_token)
    return syncActions.syncClientEstablished(client)

  })
)

export default initiate$
